module.exports = __webpack_public_path__ + "media/23.306287ff.mp3";